import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';

function Title(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			fontSize: context.themeManager.value('category-title', 'fontSize', 'font-size-200'),
			padding: '0 0 0.4em 0',
			margin: '0 0 1.2em 0',
			background: `linear-gradient(to right, rgb(51, 51, 51) 20%, rgba(255, 255, 255, 0) 0%)
			center bottom / 5px 1px repeat-x transparent`,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'baseline',
			flexWrap: 'wrap',
		},
		title: {
			textTransform: 'uppercase',
		},
		additionalText: {
			fontSize: '.8em',
		},
	};
	return (
		<div className="category__title-container" style={style.container}>
			<div className="title" style={style.title}>
				{props.name}
			</div>
			<div className="title__additional-text" style={style.additionalText}>
				{props.children}
			</div>
		</div>
	);
}

export default Title;
